import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "@/lib/data";

export const LogoMarquee = () => (
    <div className="border-y border-white/10 py-12 overflow-hidden" data-testid="logo-marquee">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {CLIENT_LOGOS.map((logo) => (
                <div
                    key={logo.name}
                    className="mx-6 md:mx-8 bg-white hover:bg-sf-green/95 transition-colors duration-500 px-8 md:px-10 h-20 md:h-24 flex items-center justify-center min-w-[190px]"
                >
                    <img
                        src={logo.src}
                        alt={logo.name}
                        title={logo.name}
                        data-testid={`client-logo-${logo.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="max-h-10 md:max-h-12 w-auto max-w-[170px] object-contain"
                    />
                </div>
            ))}
        </Marquee>
    </div>
);
